"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cccisdProgressBar = _interopRequireDefault(require("cccisd-progress-bar"));
var _cccisdRenderInBody = _interopRequireDefault(require("cccisd-render-in-body"));
var _update2 = _interopRequireDefault(require("lodash/update"));
var _randomstring = _interopRequireDefault(require("randomstring"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// create settings in global variables if they are not created yet
(0, _update2["default"])(window, 'cccisd.components.cccisd-loader', function (obj) {
  return _objectSpread({
    ids: [],
    spinnerStarted: 0
  }, obj);
});
var settings = window.cccisd.components['cccisd-loader'];
if (!settings.div) {
  settings.div = document.createElement('div');
  settings.div.className = 'cccisd-loader cccisd-loader-hidden';
  document.body.appendChild(settings.div);
}
var hideLoader = function hideLoader() {
  if (settings.ids.length === 0 && !settings.div.classList.contains('cccisd-loader-hidden')) {
    settings.spinnerStarted = 0;
    settings.div.classList.add('cccisd-loader-hidden');
  }
};

// delay to show spinner just to avoid spinner flickering
var delayStart = 300;

// show spinned for at least this time just to avoid the sequence of spinners
var minDuration = 500;
var GlobalLoader = exports["default"] = /*#__PURE__*/function (_React$Component) {
  function GlobalLoader(props) {
    var _this;
    _classCallCheck(this, GlobalLoader);
    _this = _callSuper(this, GlobalLoader, [props]);
    _defineProperty(_this, "getStopDelay", function () {
      return _this.showPercentage() || _this.props.showImmediately ? 0 : minDuration;
    });
    _defineProperty(_this, "startSpinner", function () {
      // add new ID to the array
      settings.ids = [].concat(_toConsumableArray(settings.ids), [_this.id]);
      var delay = _this.showPercentage() || _this.props.showImmediately ? 0 : delayStart;
      _this.startTimeout = setTimeout(function () {
        if (settings.ids.length > 0 && settings.div.classList.contains('cccisd-loader-hidden')) {
          settings.spinnerStarted = Date.now();
          settings.div.classList.remove('cccisd-loader-hidden');
        }
      }, delay);
    });
    _defineProperty(_this, "stopSpinner", function () {
      clearTimeout(_this.startTimeout);
      if (!settings.ids.includes(_this.id)) {
        return;
      }
      settings.ids = settings.ids.filter(function (id) {
        return id !== _this.id;
      });
      _this.stopTimeout = setTimeout(hideLoader, _this.getStopDelay());
    });
    _defineProperty(_this, "showPercentage", function () {
      return _this.props.percentage || _this.props.percentage === 0;
    });
    _this.id = _randomstring["default"].generate(10);
    return _this;
  }
  _inherits(GlobalLoader, _React$Component);
  return _createClass(GlobalLoader, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.loading) {
        this.startSpinner();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.loading && !prevProps.loading) {
        this.startSpinner();
      }
      if (!this.props.loading && prevProps.loading) {
        this.stopSpinner();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this2 = this;
      clearTimeout(this.startTimeout);
      clearTimeout(this.stopTimeout);
      settings.ids = settings.ids.filter(function (id) {
        return id !== _this2.id;
      });
      setTimeout(hideLoader, this.getStopDelay());
    }
  }, {
    key: "render",
    value: function render() {
      var progressBar = null;
      if (this.props.loading && this.showPercentage()) {
        var percentage = Math.round(Math.max(Math.min(this.props.percentage, 100), 0));
        progressBar = /*#__PURE__*/_react["default"].createElement(_cccisdRenderInBody["default"], null, /*#__PURE__*/_react["default"].createElement("div", {
          className: _style["default"].globalProgressBarWrapper
        }, /*#__PURE__*/_react["default"].createElement(_cccisdProgressBar["default"], {
          percentage: percentage
        })));
      }
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, this.props.loading && this.props.removeChildren ? null : this.props.children, progressBar);
    }
  }]);
}(_react["default"].Component);
_defineProperty(GlobalLoader, "propTypes", {
  loading: _propTypes["default"].bool,
  removeChildren: _propTypes["default"].bool,
  children: _propTypes["default"].node,
  /** By default there is a small delay before showing loader. You can omit this behaviour. */
  showImmediately: _propTypes["default"].bool,
  percentage: _propTypes["default"].number
});
_defineProperty(GlobalLoader, "defaultProps", {
  loading: false,
  removeChildren: false,
  showImmediately: false
});